import { render, staticRenderFns } from "./MdOms.vue?vue&type=template&id=989eef34&scoped=true&"
import script from "./MdOms.vue?vue&type=script&lang=js&"
export * from "./MdOms.vue?vue&type=script&lang=js&"
import style0 from "./MdOms.vue?vue&type=style&index=0&id=989eef34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989eef34",
  null
  
)

export default component.exports